export const ADRESSE_DATA_GOUV_SEARCH = "https://api-adresse.data.gouv.fr/search/";